import { BinaryWriter } from "../binary.js";
import { ServerOp } from "../opcodes.js";
import { DEFAULT_STANCE, MELEE_RANGE, SKILL_COUNT, isCombatStance, isVocation, Vocation, } from "../constants.js";
export function encodeStats(packet, writer = new BinaryWriter(80)) {
    writer
        .u8(ServerOp.Stats)
        .u16(packet.level)
        .f64(packet.experience)
        .f64(packet.levelStartExp)
        .f64(packet.nextLevelExp)
        .u16(packet.health)
        .u16(packet.maxHealth)
        .u16(packet.mana)
        .u16(packet.maxMana)
        .u32(packet.capacity)
        .u32(packet.maxCapacity)
        .u8(packet.vocation)
        .u8(packet.conditions)
        .u32(packet.foodMs)
        .u32(packet.staminaMs)
        .u8(packet.stance)
        .u8(packet.attackRange);
    for (let i = 0; i < SKILL_COUNT; i++) {
        const skill = packet.skills[i];
        writer.u16(skill?.level ?? 0).u8(skill?.percent ?? 0);
    }
    return writer;
}
export function decodeStats(reader) {
    const level = reader.u16();
    const experience = reader.f64();
    const levelStartExp = reader.f64();
    const nextLevelExp = reader.f64();
    const health = reader.u16();
    const maxHealth = reader.u16();
    const mana = reader.u16();
    const maxMana = reader.u16();
    const capacity = reader.u32();
    const maxCapacity = reader.u32();
    const rawVocation = reader.u8();
    const conditions = reader.u8();
    const foodMs = reader.u32();
    const staminaMs = reader.u32();
    const rawStance = reader.u8();
    // Alcance zero seria um personagem que não alcança o próprio tile vizinho, e o cliente o
    // usa como piso da perseguição: um byte perdido viraria um personagem que anda para
    // sempre em direção a um alvo que ele nunca considera alcançado.
    const attackRange = Math.max(MELEE_RANGE, reader.u8());
    const skills = new Array(SKILL_COUNT);
    for (let i = 0; i < SKILL_COUNT; i++) {
        skills[i] = { level: reader.u16(), percent: reader.u8() };
    }
    return {
        level,
        experience,
        levelStartExp,
        nextLevelExp,
        health,
        maxHealth,
        mana,
        maxMana,
        capacity,
        maxCapacity,
        vocation: isVocation(rawVocation) ? rawVocation : Vocation.Knight,
        conditions,
        foodMs,
        staminaMs,
        stance: isCombatStance(rawStance) ? rawStance : DEFAULT_STANCE,
        attackRange,
        skills,
    };
}
//# sourceMappingURL=stats.js.map